import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle
} from "@mui/material";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import PhoneInput from "react-phone-input-2";
// import { makeStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
// import SearchIcon from "@mui/icons-material/Search";
import SearchIcon from "@mui/icons-material/Search";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { NavLink, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { countries } from "../../utils/countriesDropdown";
import {
	getCustomerList
} from "../../redux/actions/getCustomerListAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import EditIcon from "@mui/icons-material/Edit";
// import EditIcon from "@mui/icons-material/Edit";

import {
	updateCustomerDetails
} from "../../redux/actions/updateCustomerDetails";
// import BlockIcon from "@mui/icons-material/Block";
import BlockIcon from "@mui/icons-material/Block"
import CommonLogout from "../../components/CommonLogout/CommonLogout";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import Util from "../../validation";
import {

	getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
import { Tooltip } from "antd";
// import Tooltip from "@mui/material/Tooltip";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { getUsernameContactSuggestion } from "../../redux/actions/getUsernameContactSuggestionAction";
// import Autocomplete from "@mui/material/lab/Autocomplete";
// import Tooltip from "@mui/material/Tooltip";
import Autocomplete from "@mui/material/Autocomplete";

//new
import {
	getRegenerateToken,
	resetRegenerateToken,
} from "../../redux/actions/regenerateTokenAction";



const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const CustomerMaster = () => {
	const [logoutvalue, setLogoutvalue] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useHistory();
	const [pageToggle, setPageToggle] = useState(false);
	const [open, setOpen] = React.useState(false);
	const classes = useStyles();
	const dispatch = useDispatch();
	const [getCustomerId, setGetCustomerId] = useState("");
	const [customername, setCustomername] = useState("");
	const [role, setRole] = useState("");
	const [cusid, setCusid] = useState("");
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [getCustomerListStatus, setGetCustomerListStatus] = useState(false);
	const [getCustomerListArray, setGetCustomerListArray] = useState([]);
	const [customerMob, setcustomerMob] = useState('');
	const [customerEmail, setcustomerEmail] = useState('')
	const [autocompleteCustomerIDData, setautocompleteCustomerIDData] =
		useState("");
	const updateCustomerDetail = useSelector(
		({ updateCustomerDetails }) => updateCustomerDetails
	);

	// const regenerateTokenRes = useSelector(
	// 	({ regenerateToken }) => regenerateToken
	// );
	//const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);


	const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
	var authToken = regenerateTokenRes.data.AuthToken;

	// console.log("the use selector response authtoken", regenerateTokenRes.data.AuthToken);

	//  console.log("geting auth token from local storage",token);
	//   console.log(regenerateTokenRes);
	//var authToken = regenerateTokenRes.data.authToken;

	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);
	const login = useSelector((state) => state.login);

	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [searchLoading, setSearchLoading] = useState(false);

	//update customer details
	const [updateCusid, setupdateCusid] = useState("");
	const [updateCusFn, setupdateCusFn] = useState("");
	const [updateCusGender, setupdateCusGender] = useState("");
	const [updateCusLn, setupdateCusLn] = useState("");
	const [updateCusEmail, setupdateCusEmail] = useState("");
	const [updateCusCountry, setupdateCusCountry] = useState("");
	const [updateCusCity, setupdateCusCity] = useState("");
	const [updateCusState, setupdateCusState] = useState("");
	const [updateCusPcode, setupdateCusPcode] = useState("");
	const [updateCusPhone, setupdateCusPhone] = useState("");
	const [updateCusDealUsed, setupdateCusDealUsed] = useState("");
	const [updateCusKYCAc, setupdateKYCAc] = useState("");
	const [updateCusIsActive, setupdateIsActive] = useState("");
	const [updateCusTransactionAllow, setupdateTransactionAllow] = useState("");
	const [updateCusCurrency, setupdateCusCurrency] = useState("");
	const [updateCusRole, setupdateRole] = useState("");
	const [updateCusCountryCode, setUpdateCusCountryCode] = useState("");
	const [updateCusImageBase64, setUpdateCusImageBase64] = useState("");
	const [updateCusImagePreview, setUpdateCusImagePreview] = useState("");
	const [imageUploadError, setImageUploadError] = useState("");
	const [updateCustomerDetailStatus, setUpdateCustomerDetailsStatus] =
		useState(false);
	const [updateCustomerDetailArray, setUpdateCustomerDetailArray] =
		useState("");

	const handleChange = ({ target: { name, value } }) => {
		if (name == "getCustomerId") {
			// console.log("CustIDDDD", getCustomerId)
			setGetCustomerId(value);
			// 	// Util.verifyNumber(value)
			// 	// 	? setCustomerid(value)
			// 	// 	: setCustomerid(customerid);
		}

		if (name == "customername") {
			// setCustomername(value);
			Util.verifyAlphabet(value)
				? setCustomername(value)
				: setCustomername(customername);
		}

		if (name == "role") {
			// setRole(value);
			setRole(value == "All" ? "" : value);
		}
		if (name == 'customerMob') {
			// console.log("MOB", customerMob)
			setcustomerMob(value);
		}
		if (name == 'customerEmail') {
			setcustomerEmail(value);
		}
	};

	// Reads the selected file, validates it's an image under a sane size
	// limit, and converts it to base64 for the update payload. Keeping the
	// data-URL prefix (e.g. "data:image/png;base64,") stripped off before
	// storing, since most backends expect the raw base64 payload only —
	// adjust the .split(",")[1] below if your API actually wants the full
	// data URL instead.
	const MAX_IMAGE_SIZE_BYTES = 5 * 1024 * 1024; // 5MB

	const handleImageChange = (event) => {
		const file = event.target.files && event.target.files[0];
		setImageUploadError("");

		if (!file) {
			return;
		}

		if (!file.type.startsWith("image/")) {
			setImageUploadError("Please select a valid image file.");
			event.target.value = "";
			return;
		}

		if (file.size > MAX_IMAGE_SIZE_BYTES) {
			setImageUploadError("Image must be smaller than 5MB.");
			event.target.value = "";
			return;
		}

		const reader = new FileReader();
		reader.onload = () => {
			const dataUrl = reader.result; // "data:image/png;base64,AAAA..."
			const base64Only = String(dataUrl).split(",")[1] || "";
			setUpdateCusImageBase64(base64Only);
			setUpdateCusImagePreview(dataUrl);
		};
		reader.onerror = () => {
			setImageUploadError("Could not read the selected image. Please try again.");
		};
		reader.readAsDataURL(file);
	};

	const handleRemoveImage = () => {
		setUpdateCusImageBase64("");
		setUpdateCusImagePreview("");
		setImageUploadError("");
	};

	const handleUpdateChange = ({ target: { name, value } }) => {
		if (name === "updateCusFn") {
			// setupdateCusFn(value);
			Util.verifyAlphabet(value)
				? setupdateCusFn(value)
				: setupdateCusFn(updateCusFn);
		}
		if (name === "updateCusLn") {
			// setupdateCusLn(value);
			Util.verifyAlphabet(value)
				? setupdateCusLn(value)
				: setupdateCusLn(updateCusLn);
		}

		if (name === "updateCusGender") {
			setupdateCusGender(value);
		}
		if (name === "updateCusCountry") {
			setupdateCusCountry(value);
		}

		if (name === "updateCusCity") {
			setupdateCusCity(value);
		}

		if (name === "updateCusState") {
			// setupdateCusState(value);
			Util.verifyAlphabet(value)
				? setupdateCusState(value)
				: setupdateCusState(updateCusState);
		}

		if (name === "updateCusPcode") {
			setupdateCusPcode(value);
		}
		if (name === "updateCusDealUsed") {
			setupdateCusDealUsed(value);
		}

		if (name === "updateCusKYCAc") {
			setupdateKYCAc(value);
		}

		if (name === "updateCusIsActive") {
			setupdateIsActive(value);
		}

		if (name === "updateCusTransactionAllow") {
			setupdateTransactionAllow(value);
		}

		if (name === "updateCusKYCAc") {
			setupdateKYCAc(value);
		}
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		const newRowsPerPage = parseInt(event.target.value, 10);
		const currentFirstRowIndex = page * rowsPerPage;
		const newPage = Math.floor(currentFirstRowIndex / newRowsPerPage);

		setRowsPerPage(newRowsPerPage);
		setPage(newPage);
	};

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const GetCustomerListRequest = () => {
		setGetCustomerListStatus(true);
		setSearchLoading(true);  // ← start button spinner

		setIsLoading(true);
		const req = {

			authentication: {
				// partnerId: regenerateTokenRes.data.partnerId || "",
				partnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId



			},
			customerRequestVo: {
				customerID: autocompleteCustomerIDData ? autocompleteCustomerIDData.split('-')[0] : "",
				userRole: role || "",
				customerName: customername || "",
				mobile: customerMob.split('-')[0] || '',
				customerEmail: customerEmail || ''
			}
		};
		return dispatch(getCustomerList(req, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			GetCustomerListRequest();
		}
	}, [regenerateTokenRes.data.status]);

	const getCustomerListRes = useSelector(
		({ getCustomerList }) => getCustomerList
	);

	const getUsernameContactSuggestionRes = useSelector(({ getUsernameContactSuggestion }) => getUsernameContactSuggestion);

	useEffect(() => {
		if (regenerateTokenRes.data.status === 'success') {
			const req = {
				actionCustomerMasterRequestVO:
				{
					customerMobileOrName: customerMob,
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				}
			}
			dispatch(getUsernameContactSuggestion(req, authToken))
		}
	}, [regenerateTokenRes.data.status]);

	const getUsernameSuggestionRes = useSelector(({ getUsernameContactSuggestion }) => getUsernameContactSuggestion);

	useEffect(() => {
		if (getUsernameSuggestionRes.data.status === "success") {
			// console.log("lissttt", getUsernameSuggestionRes.data.list)
		}
	}, [getUsernameSuggestionRes.data.status])

	//Customer/Beneficiery name
	const filterOptionsN = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filteredOptionsNames = options.filter(
			(option) =>

				option.customerMobileOrName && option.customerMobileOrName.includes(inputValue)
		);

		return filteredOptionsNames.slice(0, 20);
	}

	const sendCustomerId = (id) => {
		setPageToggle(true);
		navigate.push({
			pathname: `/index/getCustomerDetails`,
			search: `?userId=${id}`
		});
	};

	const handleClickBlockFunc = (id) => {
		navigate.push({
			pathname: `/index/actionCustomerMaster`,
			search: `?userId = ${id}`
		});
	};

	const handleClose = () => {
		setOpen(false);
	};

	const updateHandleClickOpen = (customerId, countries) => {
		getCustomerListArray.map((item) => {
			if (item.customerId == customerId) {
				setupdateCusid(item.customerId);
				setupdateCusFn(item.firstName);
				setupdateCusLn(item.lastName);
				setupdateCusCountry(item.country);
				setupdateCusCity(item.registeredCity);
				setupdateCusState(item.registeredState);

				countries.map((value) => {
					if (value.dial_code.split("-")[1] == item.countryCode) {
						setupdateCusCountry(value.label + value.dial_code);
					}
				});

				// setupdateCusPcode(item.countryCode);
				setUpdateCusCountryCode(item.countryCode);
				setupdateCusPhone(item.mobile);
				setupdateCusDealUsed(item.isDealUsed);
				setupdateKYCAc(item.kycAccount);
				setupdateTransactionAllow(item.isTransactionAllowed);
				setupdateRole(item.userRole);
				setupdateCusEmail(item.customerEmail);
				setupdateCusCurrency(item.currency);
				setupdateIsActive(item.isActive);
				setupdateCusGender(item.gender);
				// Prefill the preview from an existing profile image if the
				// API already returns one on the row; otherwise start blank.
				// ASSUMPTION: field name is `item.profileImage` — adjust to
				// match whatever field your getCustomerList response actually
				// uses, if it returns one at all.
				setUpdateCusImagePreview(item.logo  ? `data:image/jpeg;base64,${item.logo }` : "");
				setUpdateCusImageBase64(item.logo  || "");
				setImageUploadError("");
			}
		});
		setCusid(customerId);
		setOpen(true);
	};

	const updateCustomerDetailsApi = () => {
		setUpdateCustomerDetailsStatus(true);
		const updateCustomerDetailsReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				custmerId: updateCusid,
				loginRole: updateCusRole,
				loginName: "Mtransact"
			},
			customerMasterDetailsRequestVO: {
				customerId: updateCusid,
				firstName: updateCusFn,
				lastName: updateCusLn,
				gender: updateCusGender,
				country: `${updateCusCountry}`,
				city: updateCusCity,
				state: updateCusState,
				registeredPostal: updateCusPcode,
				isDealUsed: updateCusDealUsed,
				kycAccount: updateCusKYCAc,
				isActive: updateCusIsActive,
				isTransactionAllowed: updateCusTransactionAllow,
				logo: updateCusImageBase64 || ""
			}
		};
		return dispatch(updateCustomerDetails(updateCustomerDetailsReq, authToken));
	};

	const updateDetailsCustomer = () => {
		updateCustomerDetailsApi();
	};

	const getCustomerListStatusFunc = () => {
		if (getCustomerListRes.data.status == "Success") {
			setIsLoading(false);
			setSearchLoading(false);  // ← stop button spinner

			setGetCustomerListArray(
				[].concat(getCustomerListRes.data.customerMasterDetailsRequestVOList)
			);
		}
		if (getCustomerListRes.data.status == "Failed") {
			NotificationPopups("error", "Failed", getCustomerListRes.data.description);
			setIsLoading(false);
			setSearchLoading(false);  // ← stop button spinner

			setGetCustomerListArray(getCustomerListRes.data);
			if (
				getCustomerListRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				getCustomerListRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
		if (getCustomerListRes.data.status == "failed") {
			NotificationPopups("error", "Failed", getCustomerListRes.data.description);
			setIsLoading(false);
			setSearchLoading(false);  // ← stop button spinner

			setGetCustomerListArray(getCustomerListRes.data);
			if (
				getCustomerListRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				getCustomerListRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
		if (getCustomerListRes.data.status == "Not Found" ||
			getCustomerListRes.data.status == "NOT FOUND") {
			NotificationPopups("error", "Failed", getCustomerListRes.data.description)
			setIsLoading(false);
			setSearchLoading(false);  // ← stop button spinner

		}
	};

	useEffect(() => {
		if (getCustomerListRes.data.status == "Success") {
			setPage(0);
		}
	}, [getCustomerListRes.data.status]);

	useEffect(() => {
		if (getCustomerListStatus) {
			getCustomerListStatusFunc();
		}
	}, [getCustomerListRes.data.status]);

	const updateCustomerDetailFunc = () => {
		if (updateCustomerDetailStatus) {
			if (updateCustomerDetail.data.status == "Success") {
				setOpen(false);
				setUpdateCustomerDetailArray(updateCustomerDetail.data);
				setNotificationOpen(true);
				GetCustomerListRequest();
			}
			if (updateCustomerDetail.data.status == "failed") {
				setOpen(false);
				setUpdateCustomerDetailArray(updateCustomerDetail.data);
				setNotificationOpen(true);
				if (
					updateCustomerDetail.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateCustomerDetail.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (updateCustomerDetail.data.status == "Failed") {
				setOpen(false);
				setUpdateCustomerDetailArray(updateCustomerDetail.data);
				setNotificationOpen(true);
				if (
					updateCustomerDetail.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateCustomerDetail.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		updateCustomerDetailFunc();
	}, [updateCustomerDetail.data.status]);

	const filterOptions = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filteredOptions = options.filter(
			(option) =>
				option.mobile.toLowerCase().includes(inputValue.toLowerCase()) ||
				option.customerMobileOrName.toLowerCase().includes(inputValue.toLowerCase())
		);

		return filteredOptions.slice(0, 20);
	};

	useEffect(() => {
		if (getCustomerIdAndNameListRes.data.status === "Success") {
			// console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
		}
	}, [getCustomerIdAndNameListRes.data.status])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);

	const filterOptionsL = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						style={{ padding: "20px", justifyContent: "space-between" }}
					>
						<Grid item md={3} sm={12} xs={12} lg={3}>
							{/* <Grid item xs={12} md={4} sm={3} lg={3}> */}

							<NavLink to="/index/individualentity">
								<CustomButton
									style={{
										// padding: "2px"
										width: "max-content",
										marginLeft: "40px"
									}}
								>
									Add Individual Entity
								</CustomButton>
							</NavLink>
						</Grid>
						<Grid item md={3} sm={12} xs={12} lg={2}>
							{/* <Grid item xs={12} md={4} sm={3} lg={3}> */}

							<NavLink to="/index/legalEntity">
								<CustomButton
									style={{
										// padding: "2px"
										width: "max-content"

									}}
								>
									Add Legal Entity
								</CustomButton>
							</NavLink>
						</Grid>
						<Grid item md={3} sm={12} xs={12} lg={3}>
							{/* <Grid item xs={12} md={4} sm={3} lg={3}> */}

							<NavLink to="/index/unlockCustomerAccount">
								<CustomButton
									style={{
										// padding: "2px"
										width: "max-content"

									}}
								>
									Unlock Customer Account
								</CustomButton>
							</NavLink>
						</Grid>
						<Grid item md={3} sm={12} xs={12} lg={3}>
							{/* <Grid item xs={12} md={4} sm={3} lg={3}> */}

							<NavLink to="/index/custManualDeposit">
								<CustomButton
									style={{
										// padding: "2px"
										width: "max-content"

									}}
								>
									Manual Deposit
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						{/* <Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Customer ID"
								type="text"
								fullWidth
								// variant="standard"
								value={customerid}
								name="customerid"
								onChange={handleChange}
							/>
						</Grid> */}

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getCustomerIdAndNameListRes.data.currencyList || [""]
								)}
								getOptionLabel={(option) => option}
								filterOptions={filterOptionsL}
								value={autocompleteCustomerIDData}
								onChange={(event, value) =>
									setautocompleteCustomerIDData(value)
								}

								renderInput={(params) => (
									// <TextField
									// 	autoFocus
									// 	margin="dense"
									// 	id="name"
									// 	label="Customer ID"
									// 	// style={{ marginTop: "3px" }}
									// 	// required
									// 	type="text"
									// 	fullWidth
									// 	{...params}
									// 	// value={getCustomerId || ""}
									// 	// name="getCustomerId"
									// 	onBlur={handleChange}
									// />
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Customer ID"
										// style={{ marginTop: "3px" }}
										// required
										type="text"
										fullWidth
										{...params}
										className="new1"
										// value={getCustomerId || ""}
										// name="getCustomerId"
										onBlur={handleChange}
										sx={{
											"& .MuiInput-underline:before": {
												borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
												borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
												borderBottomColor: "gray", // White color after focus
											},
										}}
										variant="standard"
									/>
								)}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getUsernameSuggestionRes.data.list || [""]
								)}
								getOptionLabel={(option) => option.customerMobileOrName}
								filterOptions={filterOptionsN}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Name"
										// style={{ marginTop: "3px" }}
										type="text"
										fullWidth
										{...params}
										value={customername || ""}
										name="customername"
										onBlur={handleChange}
										variant="standard"
										InputProps={{
											sx: {
												"&:before": { borderBottomColor: "gray" }, // before focus
												"&:after": { borderBottomColor: "gray" },  // after focus
											},
										}}
										InputLabelProps={{
											sx: { color: 'gray' }, // Optional: if you want the label to be white
										}}

									/>
								)}
							/>


						</Grid>
						{/* <Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Customer Name"
								fullWidth
								variant="standard"
								type="text"
								name="customername"
								value={customername || ""}
								onChange={handleChange}
							/>
						</Grid> */}
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Role"
								type="name"
								fullWidth
								variant="standard"
								name="role"
								// value={role || ""}
								defaultValue={"All" || role}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="All" selected="All">
									All
								</MenuItem>
								<MenuItem value="Customer">Customer</MenuItem>
								<MenuItem value="Merchant">Merchant</MenuItem>
							</TextField>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "4px 25px" }}
					>
						<Grid item xs={12} sm={12} md={4} lg={3}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getUsernameContactSuggestionRes.data.list || [""]
								)}
								getOptionLabel={(option) => option.mobile + '-' + option.customerMobileOrName}
								filterOptions={filterOptions}
								renderInput={(params) => (
									<TextField
										margin="dense"
										id="name"
										label="Customer Mobile No."
										type="text"
										fullWidth
										{...params}
										value={customerMob || ""}
										name="customerMob"
										onBlur={handleChange}
										variant="standard"
										sx={{
											"& .MuiInput-underline:before": {
												borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
												borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
												borderBottomColor: "gray", // White color after focus
											},
										}}
									/>
								)}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Customer Email"
								fullWidth
								variant="standard"
								type="text"
								name="customerEmail"
								value={customerEmail || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							{/* <CustomButton
								style={{
									padding: "8px"
								}}
								onClick={GetCustomerListRequest}
							>
								Search <SearchIcon />
							</CustomButton> */}
							<CustomButton
								style={{ padding: "8px" }}
								onClick={GetCustomerListRequest}
								disabled={searchLoading}  // ← prevent double click
							>
								{searchLoading ? (
									<>
										Searching...&nbsp;
										<span
											className="spinner-border spinner-border-sm"
											role="status"
											aria-hidden="true"
										/>
									</>
								) : (
									<>
										Search <SearchIcon />
									</>
								)}
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getCustomerListArray.length == undefined ||
					getCustomerListArray.status == "Failed" ||
					getCustomerListStatus == false ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Customer Master
								</Typography>
							</Grid>

							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Customer Master
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3 ">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer Id{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Mobile No.
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Email
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Role
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getCustomerListArray &&
											[]
												.concat(getCustomerListArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row) => (
													<TableRow key={row.customerId}>
														<TableCell
															className="themeColor"
															style={{
																marginTop: "1rem",
																cursor: "pointer",
																fontWeight: "600"
															}}
															align="center"
															onClick={() => sendCustomerId(row.customerId)}
														>
															{row.customerId}
														</TableCell>
														<TableCell align="center">
															{row.customerName ? row.customerName : '-'}
														</TableCell>
														<TableCell align="center">
															{row.mobile ? row.mobile : '-'}
														</TableCell>
														<TableCell align="center">
															{row.customerEmail ? row.customerEmail : '-'}
														</TableCell>
														<TableCell align="center">{row.userRole ? row.userRole : '-'}</TableCell>
														<TableCell align="center" style={{ display: 'flex', justifyContent: 'center' }}>
															<Tooltip title="Edit">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		updateHandleClickOpen(
																			row.customerId,
																			countries
																		)
																	}
																>
																	{
																		<EditIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip>

															<Tooltip title="Block">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		handleClickBlockFunc(row.customerId)
																	}
																>
																	{
																		<BlockIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getCustomerListArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}

				<div>
					<Dialog open={open} onClose={handleClose}>
						<DialogTitle>Edit Customer</DialogTitle>
						<DialogContent>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Customer ID"
								type="name"
								fullWidth
								variant="standard"
								value={updateCusid || ""}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
								disabled
							/>
							<TextField
								autoFocus
								margin="dense"
								required
								label="Customer First Name"
								type="text"
								name="updateCusFn"
								fullWidth
								variant="standard"
								value={updateCusFn || ""}
								onChange={handleUpdateChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>
							<TextField
								margin="dense"
								required
								label="Customer Last Name"
								type="text"
								name="updateCusLn"
								fullWidth
								value={updateCusLn || ""}
								onChange={handleUpdateChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
								variant="standard"

							/>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Email Address"
								type="email"
								fullWidth
								variant="standard"
								value={updateCusEmail || ""}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
								disabled
							/>

							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Country"
								type="text"
								name="updateCusCountry"
								fullWidth
								variant="standard"
								value={updateCusCountry || ""}
								onChange={handleUpdateChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								{countries.map((value) => (
									<MenuItem value={value.label + value.dial_code}>
										{value.label}
									</MenuItem>
								))}
							</TextField>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="State"
								type="name"
								name="updateCusState"
								fullWidth
								variant="standard"
								value={updateCusState || ""}
								onChange={handleUpdateChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Postal Code"
								type="name"
								name="updateCusPcode"
								fullWidth
								variant="standard"
								value={updateCusPcode}
								onChange={handleUpdateChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>

							<PhoneInput
								disabled
								autoFocus
								margin="dense"
								id="name"
								label="Country"
								type="text"
								fullWidth
								variant="standard"
								name="updateCusPhone"
								value={`${updateCusCountryCode}-${updateCusPhone}`}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>

							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Deal Used"
								type="name"
								name="updateCusDealUsed"
								fullWidth
								variant="standard"
								value={updateCusDealUsed || ""}
								onChange={handleUpdateChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="1">Y</MenuItem>
								<MenuItem value="0">N</MenuItem>
							</TextField>

							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="KYC Account Type"
								type="number"
								name="updateCusKYCAc"
								fullWidth
								variant="standard"
								onChange={handleUpdateChange}
								value={updateCusKYCAc || ""}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="1">BASIC</MenuItem>
								<MenuItem value="2">STANDARD</MenuItem>
								<MenuItem value="3">PREMIUM</MenuItem>
								<MenuItem value="4">SUPREME</MenuItem>
							</TextField>

							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Is Active"
								type="name"
								name="updateCusIsActive"
								fullWidth
								variant="standard"
								value={updateCusIsActive || ""}
								onChange={handleUpdateChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>

							<TextField
								select
								autoFocus
								margin="dense"
								label="Is Transaction Allow"
								type="name"
								name="updateCusTransactionAllow"
								fullWidth
								value={updateCusTransactionAllow || ""}
								onChange={handleUpdateChange}
								variant="standard"
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}

							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>

							<TextField
								defaultValue={"Select Currency"}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label=" Currency"
								value={updateCusCurrency}
								fullWidth={true}
								disabled
								variant="standard"
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}

							></TextField>

							<TextField
								required
								autoFocus
								margin="dense"
								label="Role"
								type="text"
								fullWidth
								value={updateCusRole}
								disabled
								variant="standard"
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}

							/>

						

							{/* Profile image upload — converts the selected file to base64
							    and sends it in updateCustomerDetailsApi's
							    customerMasterDetailsRequestVO. */}
							<div style={{ marginTop: "16px", marginBottom: "8px" }}>
								<Typography variant="caption" style={{ color: "gray", display: "block", marginBottom: "6px" }}>
									Profile Image
								</Typography>

								{updateCusImagePreview && (
									<div style={{ marginBottom: "8px" }}>
										<img
											src={updateCusImagePreview}
											alt="Customer preview"
											style={{
												width: "80px",
												height: "80px",
												objectFit: "cover",
												borderRadius: "6px",
												border: "1px solid #d9d9d9"
											}}
										/>
									</div>
								)}

								<input
									type="file"
									accept="image/*"
									onChange={handleImageChange}
								/>

								{updateCusImagePreview && (
									<CustomButton
										style={{ padding: "4px 10px", marginLeft: "10px", fontSize: "12px" }}
										onClick={handleRemoveImage}
									>
										Remove
									</CustomButton>
								)}

								{imageUploadError && (
									<Typography variant="caption" style={{ color: "#d32f2f", display: "block", marginTop: "4px" }}>
										{imageUploadError}
									</Typography>
								)}
							</div>

							
						</DialogContent>
						<DialogActions>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									padding: "8px"

								}}
								disabled={!updateCusFn || !updateCusLn}
								onClick={updateDetailsCustomer}

							>
								Save
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>
			{updateCustomerDetailArray.status == "Success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateCustomerDetailArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{updateCustomerDetailArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateCustomerDetailArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateCustomerDetailArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateCustomerDetailArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{logoutvalue ? <CommonLogout /> : ""}
		</>
	);
};

export default CustomerMaster;
